import { render, staticRenderFns } from "./ReasonsDialog.vue?vue&type=template&id=c31e153e"
import script from "./ReasonsDialog.vue?vue&type=script&lang=js"
export * from "./ReasonsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports